import axios from "axios";
import { base_URL } from '../config/config';
const API_BASE_URL = `${base_URL}/api`;

export const getUsers = async (page = 1, limit = 10, apiFilter) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.get(`${API_BASE_URL}/adminUsers`, {
      params: {
        limit, page, filter: JSON.stringify(apiFilter)
      },
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error fetching users', error);
    const { data } = error.response;
    return data;
  }
}

export const createUser = async(body) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.post(`${API_BASE_URL}/adminUsers`, body, { headers: { Authorization:`Bearer ${accessToken}` }});
    return response.data;
  }
  catch(error) {
    console.error('Error creating use', error);
    const { data } = error.response;
    return data;
  }
}

export const updateUser = async(id, body) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.put(`${API_BASE_URL}/adminUsers/${id}`, body, {
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error updating user', error);
    const { data } = error.response;
    return data;
  }
}

export const deleteUser = async(id) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.delete(`${API_BASE_URL}/adminUsers/${id}`, {
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error deleting user', error);
    const { data } = error.response;
    return data;
  }
}

export const getUser = async(id) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.get(`${API_BASE_URL}/adminUsers/${id}`, {
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error deleting user', error);
    const { data } = error.response;
    return data;
  }
}



export const changeStatus = async(id, body) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.post(`${API_BASE_URL}/users/changeStatus/${id}`,body, {
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error deleting user', error);
    const { data } = error.response;
    return data;
  }
}

export const changePassword = async(body) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.post(`${API_BASE_URL}/auth/admin-change-password`, body, { headers: { Authorization:`Bearer ${accessToken}` }});
    return response.data;
  }
  catch(error) {
    console.error('Error changing password', error);
    const { data } = error.response;
    return data;
  }
}

export const forgotPassword = async(body) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/admin-forgot-password`, body);
    return response.data;
  }
  catch(error) {
    console.error('Error resetting password', error);
    const { data } = error.response;
    return data;
  }
}

export const resetPassword = async (body) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/admin-reset-password`, body);
    return response.data;
  }
  catch(error) {
    console.error('Error resetting password', error);
    const { data } = error.response;
    return data;
  }
}